import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import brand from '../../../../utils/brand';
import PapperBlock from '../../../../components/PapperBlock/PapperBlock';
import Hidden from '@material-ui/core/Hidden';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Button, Typography } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import classNames from 'classnames';
import AddIcon from '@material-ui/icons/Add';
import styles from '../../../../components/Tables/tableParts/tableStyle-jss';
import ls from 'local-storage';
import { fetchCall } from '../../../../service/service_base';
import AddKicker from './AddKicker';
import Icon from '@material-ui/core/Icon';
import Snackbar from '@material-ui/core/Snackbar';
import CustomNotification from '../../../../components/Notification/CustomNotification';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import ConfirmDialog from '../../../../components/Dialog/ConfirmDialog';
import LoaderFull from '../../../../components/Loader/LoaderFull';
import { ThemeContext } from '../../../../utils/ThemeContext';
import Switch from '@material-ui/core/Switch';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: '#9F9F9F',
    padding: '4px 24px 4px 24px',
  },
  body: {
    padding: '4px 24px 4px 24px',
    fontSize: 14,
  },
}))(TableCell);


class Kickers extends React.Component {

  constructor(props) {
    super(props);
  }

  state = {
    anchorEl: null,
    dataKicker: [],
    openAddKicker: false,
    kickerSelected: null,
    editKicker: false,
    openNotification: false,
    typeNotification: "info",
    messageNotification: "",
    canEdit: true,
    canShow: false,
    canPublish: true,
    canDelete: true,
    searchData: [],
    openConfirmDialog: false,
    idDelete: 0,
    isLoading: true,
    currentUser: ls.get("current_user")['user_id']
  }

  handleCloseNotification = () => {
    this.setState({ openNotification: false, messageNotification: '' });
  }

  componentDidMount() {
    this.context.toggleTheme(undefined);
    this._getUserPermissions();
  }

  _getUserPermissions = () => {
    let currentUser = ls.get("current_user");
    let permissionsCurrentUser = JSON.parse("[" + currentUser.menuSynthesis + "]");
    if (permissionsCurrentUser[0] != null) {
      let add = permissionsCurrentUser.find(x => x.name === "Configuración/Catálogos/Kickers");

      if (add !== undefined) {
        let currentPermissions = ls.get("permissions");
        if (currentPermissions != undefined || currentPermissions !== null) {

          let data = currentPermissions.filter(x => x.menu_id == add.id)[0];
          if (data != undefined) {
            let config = JSON.parse(data.grant_configuration);
            this.setState({
              canShow : config.chkViewKicker,
              canEdit : config.chkEditKicker,
            })
            this._getUsersByList()
          }

        }
      }
    }

  }

  _getUsersByList = () => {
    fetchCall("GET", "/kicker/get").then(response => {
      this.setState({
        dataKicker: response.data,
        searchData: response.data,
        isLoading: false
      });
    }).catch(err => console.log(err));
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  _handleOpenAddKicker = () => {
    this.setState({
      openAddKicker: true,
      kickerSelected: null,
      editKicker :false
    })
  }

  closeNewKicker = () => {
    this.setState({
      kickerSelected: null,
      openAddKicker: false
    })
  }

  submitKicker = (event, data) => {
    event.preventDefault();
    this.setState({ isLoading: true });
    data.active = 1;
    if (data.kicker_name.toString().trim() === '') {
      this.setState({
        openNotification: true,
        messageNotification: 'Debes ingresar un nombre',
        typeNotification: 'warning',
        isLoading: false
      });
      return false;
    }
    if (!this.state.editKicker) {
      let exists = this.state.dataKicker.find(x => x.kicker_name == data.kicker_name.toString().trim().toLowerCase());
      if (exists != undefined) {
        this.setState({
          openNotification: true,
          messageNotification: 'Ya existe un kicker con este nombre',
          typeNotification: 'warning',
          isLoading: false
        });
        return false;
      }
      fetchCall("POST", "/kicker/add", data).then(response => {
        if (response.status == 200) {
          this.setState({
            openAddKicker: false,
            editKicker: false,
            openNotification: true,
            messageNotification: "Se agregó el kicker",
            typeNotification: 'success',
            isLoading: false
          });
          this._getUsersByList();
        }
      }).catch(err => console.log(err));
    } else {
      let exists = this.state.dataKicker.filter(x => x.kicker_name === data.kicker_name.toString().trim().toLowerCase() && x.kicker_id !== this.state.kickerSelected.kicker_id)[0];
      if (exists != undefined) {
        this.setState({
          openNotification: true,
          messageNotification: 'Ya existe un kicker con este nombre',
          typeNotification: 'warning',
          isLoading: false
        });
        return false;
      }
      data.kicker_id = this.state.kickerSelected.kicker_id;
      data.kicker_photo = this.state.kickerSelected.kicker_photo;
      fetchCall("POST", "/kicker/update", data).then(response => {
        if (response.status == 200) {
          this.setState({
            openAddKicker: false,
            editKicker: false,
            openNotification: true,
            messageNotification: "Se modificó el kicker",
            typeNotification: 'success',
            isLoading: false,
            kickerSelected: null
          });
          this._getUsersByList();
        }
      }).catch(err => console.log(err));
    }
  }

  _handleEditKicker = (kicker) => {
    this.setState({
      kickerSelected: kicker,
      openAddKicker: true,
      editKicker: true
    })
  }

  _handleDeleteKicker = () => {
    this.setState({ isLoading: true });
    this.state.kickerSelected.active = 2;
    fetchCall("POST", "/kicker/update", this.state.kickerSelected).then(response => {
      if (response.status == 200) {
        this.setState({
          openNotification: true,
          messageNotification: "Se eliminó " + this.state.kickerSelected.kicker_name,
          typeNotification: 'success',
          openConfirmDialog: false,
          idDelete: 0,
          isLoading: false
        })
        this._getUsersByList();
      }
    }).catch(err => console.log(err))
  }

  handleStatus = (item) => {
    this.setState({ isLoading: true });
    item.active = item.kicker_status == 1 ? 0 : 1
    item.menu_id = 0
    fetchCall("POST", "/kicker/update", item).then(response => {
      if (response.status == 200) {
        this.setState({
          openNotification: true,
          messageNotification: "Se cambió el estatus a " + item.kicker_name,
          typeNotification: 'success',
          openConfirmDialog: false,
          idDelete: 0,
          isLoading: false
        })
        this._getUsersByList();
      } else {
        this.setState({
          openNotification: true,
          messageNotification: "Ocurrió un error al cambiar el estatus",
          typeNotification: "error",
          isLoading: false
        });
      }
    }).catch(err => console.log(err));
  }

  _search = (event) => {
    let searchWord = event.target.value.toString().toLowerCase();
    let result = this.state.dataKicker.slice(0);
    var arr = [];
    arr = result.filter(x => {
      if (`${x.kicker_name}`.toLowerCase().includes(searchWord)) {
        return x;
      }
    });
    this.setState({ searchData: arr });
  }

  _openConfirmDialog = (kicker) => {
    this.setState({
      openConfirmDialog: true,
      kickerSelected: kicker
    });
  }

  _closeConfirmDialog = () => {
    this.setState({
      openConfirmDialog: false,
      kickerSelected: null
    });
  }

  render() {
    const {
      classes
    } = this.props;
    const title = brand.name + ' - Contáctos';
    const description = brand.desc;
    return (
      <div>
        <Helmet>
          <meta name="description" content={description} />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="twitter:title" content={title} />
          <meta property="twitter:description" content={description} />
        </Helmet>

        {this.state.isLoading ? <LoaderFull /> : ''}

        <AddKicker
          openForm={this.state.openAddKicker}
          closeForm={this.closeNewKicker}
          classes={classes}
          submit={this.submitKicker}
          dataInit={this.state.kickerSelected}
        />

        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={this.state.openNotification}
          autoHideDuration={6000}
          onClose={this.handleCloseNotification}>
          <CustomNotification
            onClose={this.handleCloseNotification}
            variant={this.state.typeNotification}
            message={this.state.messageNotification} />
        </Snackbar>

        <ConfirmDialog
          title={"¿Está seguro que desea eliminar el kicker?"}
          message={"El kicker al ser eliminado no se podrá recuperar"}
          textAccept={"Aceptar"}
          textCancel={"Cancelar"}
          funcAccept={this._handleDeleteKicker}
          funcCancel={this._closeConfirmDialog}
          open={this.state.openConfirmDialog}
        />

        <PapperBlock title="Kickers" fullTitle>
          <div>
            <Toolbar className={classes.toolbar}>
              <div className={classes.title}>
                {/* TODO: AGREGAR INPUT DE BUSQUEDA */}

                <div className={classes.flex}>
                  <div className={classes.searchWrapper}>
                    <div className={classes.search}>
                      <SearchIcon />
                    </div>
                    <input className={classes.input} onChange={(event) => this._search(event)} placeholder="Buscar kicker" />
                  </div>
                </div>
              </div>

              {/* <div className={classes.spacer} /> */}
              <div className={classes.actions}>
                <Hidden xsDown>
                  <Button variant="raised" onClick={this._handleOpenAddKicker} color="secondary" className={classes.button}>
                    <AddIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
                    Nuevo
              </Button>
                </Hidden>
                <Hidden smUp>
                  <Tooltip title="Nuevo" placement="top">
                    <Button variant="fab" onClick={this._handleOpenAddKicker} mini color="secondary" aria-label="add">
                      <AddIcon className={classNames(classes.iconSmall)} />
                    </Button>
                  </Tooltip>
                </Hidden>

              </div>
            </Toolbar>
            <Paper className={classes.rootTable}>
              <div className={classes.maxHeightTable}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      {/* <CustomTableCell align="right">
                      <Checkbox
                          checked={this.state.checkedA}
                          onChange={this.handleChange('checkedA')}
                          value="checkedA"
                        />
                      </CustomTableCell> */}
                      <CustomTableCell align="right">Nombre</CustomTableCell>
                      <CustomTableCell align="right">Tipo de síntesis</CustomTableCell>
                      <CustomTableCell align="right">Estatus</CustomTableCell>
                      <CustomTableCell align="right">Acciones</CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.searchData.map((row, i) => {
                      return (
                        <TableRow className={classes.row} key={row.kicker_id}>
                          <CustomTableCell component="th" scope="row">
                            {row.kicker_name}
                          </CustomTableCell>
                          <CustomTableCell align="right">{row.menu_name}</CustomTableCell>
                          <CustomTableCell align="right">
                            <Switch
                              disabled={!this.state.canEdit}
                              checked={row.kicker_status === 1 ? true : false}
                              onChange={() => { this.handleStatus(row) }}
                              value="checkedB"
                              color="primary"
                            />
                          </CustomTableCell>
                          <CustomTableCell align="right">
                            <div key={i} className={classes.contentIcons}>
                              <Tooltip title="Editar">
                                <IconButton disabled={!this.state.canEdit}  onClick={() => {
                                  this._handleEditKicker(row)
                                }} color="secondary" className={classes.button}>
                                  <Icon>edit</Icon>
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Eliminar">
                                <IconButton disabled={!this.state.canEdit} onClick={() => {
                                  this._openConfirmDialog(row)
                                }} color="secondary" className={classes.button}>
                                  <Icon>delete</Icon>
                                </IconButton>
                              </Tooltip>
                            </div>
                          </CustomTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
              {
                this.state.searchData.length === 0 ?
                  <Typography className={classes.noMatch}>No se encontraron kickers con ese criterio de búsqueda</Typography> : ''
              }
            </Paper>
          </div>
        </PapperBlock>
      </div>
    );
  }
}

Kickers.propTypes = {
  classes: PropTypes.object.isRequired
};

Kickers.contextType = ThemeContext;

export default withStyles(styles)(Kickers);
